import React, {useContext, useEffect, useState} from 'react';
import FilterCard from './common/components/FilterCard';
import View from './common/components/View';
import FavoritesFilter from './common/components/FavoritesFilter';
import FacilityFilter from './common/components/FacilityFilter';
import DropdownFilter from './common/components/DropdownFilter';
import {FilterContext} from './common/context/filterContext';
import '../assests/css/filters.scss';

export interface filterProps {
    wholesalaerSelected: boolean
}

export default function Filters(props: filterProps) {

    const {wholesalaerSelected} = props;

    const {filterContent, filterData,
        setFilterContent} = useContext(FilterContext);
    const [favoritesChecked, setFavoritesChecked] =
        useState(filterContent.favourites === null ||
            filterContent.favourites.length === 0? false: true);

    const handleFavoriteCheck = (checked: boolean) => {
        if (checked) {
            setFilterContent({...filterContent,
                favourites: null});
            setFavoritesChecked(false);
        } else {
            setFilterContent({...filterContent,
                favourites: filterData.favourites});
            setFavoritesChecked(true);
        }
    }

    useEffect(()=> {
        if (filterContent.favourites === null) {
            setFavoritesChecked(false);
        }
    }, [filterContent.favourites])

    return (
        <div className="filters-container">
            <FilterCard>
                <View disable={wholesalaerSelected}/></FilterCard>
            <FilterCard>
                <FavoritesFilter disableFilter={wholesalaerSelected}
                    checked={favoritesChecked}
                    onChange={(checked)=> handleFavoriteCheck(checked)}/>
            </FilterCard>
            <FilterCard>
                <DropdownFilter filterName='Coverage' currentFilter={filterContent.coverage} dropdownData={filterData.coverage} filterType='coverage'
                disableFilter={wholesalaerSelected}
                />
                <FacilityFilter facilityTypeData={filterData.facilityType}
                    currentFilter={filterContent.facilityType}
                    disableFilter={wholesalaerSelected}/>
                <DropdownFilter filterName='Carrier' currentFilter={filterContent.carrier} dropdownData={filterData.carrier} filterType='carrier'
                disableFilter={wholesalaerSelected}/>
                <DropdownFilter filterName='Wholesaler' currentFilter={filterContent.wholesaler} dropdownData={filterData.wholesaler} filterType='wholesaler'
                    disableFilter={wholesalaerSelected}/>
                <DropdownFilter filterName='States' currentFilter={filterContent.states} dropdownData={filterData.states} filterType='states'
                disableFilter={wholesalaerSelected}/>
            </FilterCard>   
        </div>
    );

}